function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as l, jsxs as i } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: c , size: e = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = s(), r = c !== null && c !== void 0 ? c : n ? a.colors.inverse : a.colors.neutralHigh, { skinName: o  } = h();
    return o.match(/^blau/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ l("path", {
            fill: r,
            d: "M12 20.637c-4.601 0-8.637-4.036-8.637-8.637 0-4.601 4.036-8.637 8.637-8.637 4.6 0 8.637 4.036 8.637 8.637 0 4.6-4.036 8.637-8.637 8.637zM2 12c0 5.327 4.673 10 10 10s10-4.673 10-10S17.327 2 12 2 2 6.673 2 12zm8.348 1.466l-1.585-1.629a.682.682 0 00-.963.964l2.548 2.593 5.717-5.83a.682.682 0 00-.964-.964"
        })
    })) : o.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: r,
                d: "M10.633 14.164l6.317-6.15a.726.726 0 011.03 0 .704.704 0 010 1.023l-7.38 7.247-3.593-3.721a.7.7 0 01.027-1.023.724.724 0 011.032.029l2.567 2.595z"
            }),
            /* @__PURE__ */ l("path", {
                fill: r,
                d: "M12 2C6.484 2 2 6.484 2 12s4.484 10 10 10 10-4.484 10-10S17.516 2 12 2zm0 18.576c-4.728 0-8.576-3.848-8.576-8.576 0-4.728 3.848-8.576 8.576-8.576 4.728 0 8.576 3.848 8.576 8.576 0 4.728-3.848 8.576-8.576 8.576z"
            })
        ]
    })) : /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ l("path", {
                fill: r,
                d: "M9.947 16.64c.11.138.276.217.451.217h.013a.572.572 0 00.451-.232l6.452-8.639a.575.575 0 10-.922-.69l-6.01 8.044-2.489-3.128a.577.577 0 00-.9.718l2.954 3.71z"
            }),
            /* @__PURE__ */ l("path", {
                fill: r,
                d: "M11.997 23c-3.495 0-6.213-.912-8.079-2.711C1.981 18.424 1 15.637 1 12.005c0-3.633.981-6.423 2.918-8.29C5.784 1.914 8.505 1 11.998 1c3.495 0 6.213.912 8.081 2.711C22.018 5.58 23 8.37 23 12.001c0 3.633-.984 6.42-2.922 8.288C18.21 22.088 15.492 23 11.997 23zm0-20.78c-6.49 0-9.78 3.29-9.78 9.785 0 6.488 3.29 9.779 9.78 9.779 6.492 0 9.787-3.291 9.787-9.78 0-6.49-3.295-9.785-9.787-9.785z"
            })
        ]
    }));
}, v = m;
export { v as default };
